module.exports = __webpack_public_path__ + "img/棒球.4b257cfd.jpg";